<template>
  <div>
    <template v-if="showSurveyModal">
      <survey-modal :show-modal="showModal" />
    </template>
    <b-modal :visible="modal" @hide="resetAndCloseModal" v-b-modal="modalName">
      <template v-if="errorType === ''">
        <div slot="modal-title">
          {{ returnTitle }}
        </div>
      </template>
      <template v-else>
        <div slot="modal-title" class="danger-text">
          {{ returnTitle }}
        </div>
      </template>
      <b-container class="step" fluid v-if="currentStep === 1">
       <b-row class="text-center">
          <div class="col-12">
            <h5
              class="danger-text"
              v-html="$t(
                'returnConfirmation',
                { count, hostIds, license: count === 1 ? $t('license') : $tc('licenses', 2) }
              )"   
            />
            <h6 class="description">{{ $t('returnConfirmationInfo') }}</h6>
          </div>
        </b-row>
          <b-row class="text-left">
            <div class="col-sm-12 col-md">
              <fieldset class="form-group">
                <legend>{{ $t('selectReason') }} <span class="required-colour">*</span></legend>
                <div class="select-container">
                  <b-select
                   v-model="reasonOption"
                    :options="reasonOptions"
                    @change.native="onReasonSelect"
                    required
                  />
                </div>
              </fieldset>
              <div v-if="showRenameText">
                <span class="align-left warning-colour"
                  v-html="$t('returnRenameReason', {
                    warningLicenseRehostLink: UrlBuilder.warningLicenseRehostLink
                  })"
                />
              </div>
            </div>
          </b-row>
          <b-row class="text-left pt-3" v-if="showOtherInput">
            <div class="col-sm-12 col-md">
              <fieldset class="form-group">
                <legend>{{ $t('otherReason') }} <span class="required-colour">*</span></legend>
                <div class="select-container">
                  <b-input v-model="otherReason" />
                </div>
              </fieldset>
            </div>
          </b-row>
          <b-row class="text-left pt-3">
            <div class="col-sm-12 col-md">
              <input type="checkbox" name="consentCheckbox" v-model="consent" />
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span class="align-left required-colour"
                v-html="$t('eformlegalTextCheck',  {
                  endUserLicenseAgreement: UrlBuilder.endUserLicenseAgreement,
                  rightToAuditCompliance: UrlBuilder.rightToAuditCompliance
                })"
              />
              </b-form-checkbox>
            </div>
          </b-row>
          <b-row>
          </b-row>
        <b-row style="padding-top: 30px;">
          <div class="col-6">
            <b-button
              class="return-modal-btn btn-c-outline"
              variant="primary"
              size="lg"
              @click="returnLicenses"
              :title="$t('returnYes')"
              v-b-modal="modalName"
              :disabled="!reasonOption || !consent || (!(showOtherInput && otherReason) && showOtherInput)"
            >
              {{ $t('returnYes') }}
            </b-button>
          </div>
          <div class="col-6">
            <b-button
              class="return-modal-btn btn-c-outline"
              variant="primary"
              size="lg"
              @click="resetAndCloseModal"
              :title="$t('returnNo')"
              v-b-modal="modalName"
            >
              {{ $t('returnNo') }}
            </b-button>
          </div>
        </b-row>
      </b-container>
      <b-container fluid class="step text-center" v-else-if="currentStep === 2">
        <b-row>
          <div class="col-12">
            <h5>{{ $t('returnConfirmationLoadingHeader') }}</h5>
            <h6 class="description">{{ $t('allocateConfirmationLoadingInfo') }}</h6>
          </div>
        </b-row>
        <b-row>
          <div class="col-12">
            <loading customStyle="padding: 10px;" />
          </div>
        </b-row>
      </b-container>
      <b-container fluid v-else-if="currentStep === 3">
        <b-row>
          <div class="col-12">
            <h6 class="step description">{{ $t('returnConfirmationFinalInfo', { count }) }}</h6>
            <h5
              class="step danger-text"
              v-html="$t('returnConfirmationFinalTitle', { hostValue: hostIds })"
            />
            <span class="align-left"
              v-html="$t('rehostLegalText', {
                endUserLicenseAgreement: UrlBuilder.endUserLicenseAgreement,
                rightToAuditCompliance: UrlBuilder.rightToAuditCompliance
              })"
            />
          </div>
        </b-row>
        <b-row class="step" style="padding: 20px 0;">
          <div class="col-12">
            <b-button
              class="return-modal-btn btn-c-outline final-btn"
              variant="primary"
              size="lg"
              @click="resetAndCloseModal"
            >
              {{ $t('closeWindow') }}
            </b-button>
          </div>
        </b-row>
      </b-container>
      <b-container fluid class="step" v-else>
        <b-row>
          <div class="col-12">
            <div class="description" v-html="errorDescription" />
          </div>
        </b-row>
        <b-row v-if="errorType === 'data'" class="buttons-container text-center">
          <div class="col-12">
            <b-button
              class="secondary-btn"
              variant="primary"
              size="lg"
              @click="downloadFailedTextFile"
            >
              {{ $t('allocateFailSecondaryButtonText') }}
            </b-button>
          </div>
        </b-row>
      </b-container>
      <div slot="modal-footer" />
    </b-modal>
  </div>
</template>


<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import download from 'downloadjs'
import Loading from './Loading'
import SurveyModal from './SurveyModal'

export default {
  name: 'ReturnAllocationModal',
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    selectedLicenses: { type: Array, required: true },
    isFromViewAll: { type: Boolean, default: false },
    isFromDetailPage: { type: Boolean, default: false }
  },
  components: {
    loading: Loading,
    'survey-modal': SurveyModal
  },
  data () {
    return {
      isInternal: window.location.host.includes('citrite.net'),
      currentStep: 1,
      errorType: '',
      failedReturns: [],
      modalName: 'survey-license-modal',
      showModal: false,
      showOtherInput: false,
      showRenameText: false,
      consent: false,
      otherReason: '',
      reasonOption: '',
      reasonOptions: [
      { value: this.$t('returnReasonOption1'), text: this.$t('returnReasonOption1') },
          { value: this.$t('returnReasonOption2'), text: this.$t('returnReasonOption2') },
          { value: this.$t('returnReasonOption3'), text: this.$t('returnReasonOption3') },
          { value: this.$t('returnReasonOption4'), text: this.$t('returnReasonOption4') },
          { value: this.$t('returnReasonOption5'), text: this.$t('returnReasonOption5') },
          { value: this.$t('returnReasonOption6'), text: this.$t('returnReasonOption6') },
          { value: this.$t('returnReasonOption7'), text: this.$t('returnReasonOption7') },
          { value: this.$t('returnReasonOptionOther'), text: this.$t('returnReasonOptionOther') }
      ]
    }
  },
  computed: {
    ...mapGetters(['showSurveyModal', 'person']),
    customerId () {
      return this.$store.getters.person.customerId
    },
    loggedInUserName () {
      return this.$store.getters.authToken.userName || ''
    },
    loggedInUserPersonID () {
      return this.$store.getters.authToken.personId || ''
    },
    count () {
      if (this.isFromDetailPage) {
        return this.selectedLicenses[0].Fulfillments
          .reduce((acc, cur) => acc + (+cur.fulfilledQuantity), 0)
      }
      return this.selectedLicenses.reduce((acc, cur) => {
        acc += cur.UserCount - cur.RemainingUserCount
        return acc
      }, 0)
    },
    hostIds () {
      if (this.isFromDetailPage) {
        const HostValues = []
        this.selectedLicenses[0].Fulfillments.forEach(l => {
          if (!HostValues.includes(l.hostIDValue)) {
            HostValues.push(l.hostIDValue)
          }
        })
        return HostValues.join(', ')
      } else {
        const HostValues = []
        this.selectedLicenses.forEach(f => {
          const hostValues = f.HostValue.split(',')
          if (!HostValues.includes(...hostValues)) {
            HostValues.push(...new Set(hostValues))
          }
        })
        return HostValues.join(', ')
      }
    },
    returnTitle () {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorTitle')
        case 'system':
          return this.$t('failSystemErrorTitle')
        default:
          return this.$t('returnAllLicenses')
      }
    },
    errorDescription () {
      switch (this.errorType) {
        case 'data':
          return this.$t('failDataErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          })
        case 'system':
          return this.$t('failSystemErrorDescription', {
            customerServiceUrl: this.UrlBuilder.customerServiceUrl
          })
        default:
          return ''
      }
    },
    failedDownloadText () {
      return `${this.$t('referCustomerCare')}\r\n\r\n` +
        `${this.$t('unableToAllocatePrefix')}\r\n\r\n` +
        `${this.failedReturns.join('\r\n')}\r\n\r\n` +
        `${this.$t('unableToAllocateSuffix')}\r\n\r\n` +
        `${this.$t('contactCitrix')}`
    }
  },
  methods: {
    onReasonSelect () {
      this.$nextTick(() => {
        this.showOtherInput = (this.reasonOption === this.$t('returnReasonOptionOther'))
        this.showRenameText = (this.reasonOption === this.$t('returnReasonOption3') || this.reasonOption === this.$t('returnReasonOption5'))
      })
    },
    returnLicenses () {
      this.currentStep = 2
      this.bottle.post(this.UrlBuilder.returnUrl, {
        customerId: this.customerId,
        loggedInUserName: this.loggedInUserName,
        loggedInUserPersonID: this.$store.getters.person.id,
        action: 'Doreturn',
        fulfillmentsList: this.isFromDetailPage
          ? this.selectedLicenses[0].Fulfillments.map(l => ({
            activationID: this.selectedLicenses[0].ActivationID,
            fulfillmentID: l.fulfillmentID,
            hostValue: l.hostIDValue,
            hostType: l.hostIDType,
            quantity: l.fulfilledQuantity,
            productName: this.selectedLicenses[0].ProductName,
            serialNumber: this.selectedLicenses[0].SerialNumber,
            licenseItemNumber: this.selectedLicenses[0].LicenseItemNumber,
            assetID: this.selectedLicenses[0].AssetID,
            actionReason: this.otherReason ? this.otherReason : this.reasonOption,
            consentBy: this.consent ? this.person.username : ''
          }))
          : this.selectedLicenses.map(l => ({
            activationID: l.ActivationID,
            fulfillmentID: this.isFromViewAll ? null : l.fulfillmentID,
            hostValue: this.isFromViewAll ? null : l.hostIDValue,
            hostType: this.isFromViewAll ? l.HostType : l.hostIDType,
            quantity: this.isFromViewAll ? l.UserCount - l.RemainingUserCount : l.fulfilledQuantity,
            productName: l.ProductName,
            serialNumber: l.SerialNumber,
            licenseItemNumber: l.LicenseItemNumber,
            assetID: l.AssetID,
            actionReason: this.otherReason ? this.otherReason : this.reasonOption,
            consentBy: this.consent ? this.person.username : ''
          }))
      })
        .then(({ data }) => {
          data = data.fulfillmentsList
          Vue.AppInsights.trackEvent('Return action', {
            customerId: this.customerId,
            data: data.map(d => ({
              hostType: d.hostIDType,
              hostId: d.hostIDValue,
              quantity: d.quantity,
              status: d.status,
              remainingQuantity: d.remainingQuantity
            }))
          })
          if (data.some(d => d.statusInfo === 'FAILURE')) {
            const failedReturns = data
              .filter(d => d.statusInfo === 'FAILURE')
              .map(d => d.fulfillmentID)
            this.selectedLicenses.forEach((l) => {
              let arr
              if (failedReturns.includes(l.FulfillmentID)) {
                arr = [...this.failedReturns]
                arr.push(l)
                this.failedReturns = arr.map(l => l.FulfillmentID)
              }
            })
            this.currentStep = 4
            this.errorType = 'data'
          } else {
            this.currentStep = 3
          }
        })
        .catch((error) => {
          this.currentStep = 4
          this.errorType = 'system'
          this.loggly.log({
            errorMessage: 'Failed to fetch all licenses',
            errorObject: error,
            errorStack: error.stack
          })
        })
    },
    downloadFailedTextFile () {
      download(this.failedDownloadText, 'failed-licenses.txt', 'text/html')
    },
    resetAndCloseModal () {
      this.showModal = true
      this.currentStep = 1
      this.errorType = ''
      this.otherReason = ''
      this.showOtherInput = false
      this.showRenameText = false
      this.consent = false
      this.reasonOption = ''
      this.closeModal()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.primary-text {
  color: $primary;
}

.success-text {
  color: $success;
}

.danger-text {
  color: $danger;
}

.step {
  text-align: center;
}

.align-left {
  text-align: left;
}

.step h5 {
  font-size: 26px;
  font-weight: 400;
}

.step .description {
  font-size: 18px;
  font-weight: 400;
}

.return-modal-btn {
  width: 100%;
  border-radius: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.final-btn {
  width: auto;
  padding-left: 50px;
  padding-right: 50px;
}

.buttons-container {
  margin-top: 20px;
}

.modal-input {
  display: inline-block;
  height: 48px;
  width: 80px;
  max-width: 80px;
  margin-top: 12px;
}

fieldset {
  border: 1px solid $lightGray;
  border-radius: 5px;
  padding: 12px 0 0;
  width: 100%;
}
fieldset > legend {
  padding: 0 10px;
  margin-left: 10px;
  width: auto;
  font-size: 0.75rem;
  color: $darkGray;
  margin-bottom: 0;
  z-index: $legendZIndex;
  position: relative;
  background-color: white;
}
.select-container {
  margin: -20px 0 0;
}
select {
  border: none !important;
  height: 30px;
  width: 100% !important;
  text-indent: 10px;
}
select {
  font-size: 1rem;
}
select:hover,
select:focus,
select:active {
  outline: 0 !important;
  border: none !important;
  box-shadow: none !important;
}
.required-colour {
  color: red;
}
.warning-colour {
  color: #FFCC00;
}
</style>


// WEBPACK FOOTER //
// src/components/ReturnAllocationModal.vue